// 比较方式选项（同比/环比）
export var COMPARISON_OPTIONS = [
    { label: "年同比辅助线", value: "年同比" },
    { label: "周环比辅助线", value: "周环比" },
];
// 排序方式选项
export var SORT_OPTIONS = [
    { label: "价格", value: "价格" },
    { label: "数量", value: "数量" },
];
// 时间粒度选项（顺序：7天、30天、12个月，供 RevPAR / 房态健康 / 渠道信息等组件使用）
export var GRANULARITY_OPTIONS = [
    { label: "过去7天", value: "日度7天" },
    { label: "过去30天", value: "日度30天" },
    { label: "过去12个月", value: "月度" },
];
// 房型选择选项
export var ROOM_TYPE_OPTIONS = [
    { label: "全部", value: "全部" },
    { label: "房型1", value: "房型1" },
    { label: "房型2", value: "房型2" },
];
// 渠道信息排序选项
export var CHANNEL_SORT_OPTIONS = [
    { label: "按客单价排序", value: "按客单价排序" },
    { label: "按订单量排序", value: "按订单量排序" },
];
// 渠道分析排序选项
export var CHANNEL_ANALYSIS_SORT_OPTIONS = [
    { label: "按间夜数排序", value: "按间夜数排序" },
    { label: "按收入排序", value: "按收入排序" },
];
// 价格排序选项
export var PRICE_SORT_OPTIONS = [
    { label: "按最高价", value: "最高价" },
    { label: "按最低价", value: "最低价" },
    { label: "按最大差价", value: "最大差价" },
    { label: "按超最低价", value: "超出最低价" },
    { label: "按超最高价", value: "超出最高价" },
];
// 实时房态排序选项
export var ROOM_STATUS_SORT_OPTIONS = [
    { label: "按出租率", value: "出租率" },
    { label: "按总房量", value: "总房量" },
    { label: "按剩余房量", value: "剩余房量" },
];
// 远期房态显示模式选项
export var ROOM_STATUS_DISPLAY_MODE_OPTIONS = [
    { label: "已占用房量", value: "已占用" },
    { label: "可售房量", value: "可售" },
];
// 订单流速时间粒度选项（value 仍为「小时|天」以兼容 URL orderTrafficGranularity 与图表分支）
export var ORDER_TRAFFIC_GRANULARITY_OPTIONS = [
    { label: "过去24小时", value: "小时" },
    { label: "过去7天", value: "天" },
];
